var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLock = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 11.5C4.17157 11.5 3.5 12.1716 3.5 13V20C3.5 20.8284 4.17157 21.5 5 21.5H19C19.8284 21.5 20.5 20.8284 20.5 20V13C20.5 12.1716 19.8284 11.5 19 11.5H5ZM2.5 13C2.5 11.6193 3.61929 10.5 5 10.5H19C20.3807 10.5 21.5 11.6193 21.5 13V20C21.5 21.3807 20.3807 22.5 19 22.5H5C3.61929 22.5 2.5 21.3807 2.5 20V13Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.5C10.8065 2.5 9.66193 2.97411 8.81802 3.81802C7.97411 4.66193 7.5 5.80653 7.5 7V11C7.5 11.2761 7.27614 11.5 7 11.5C6.72386 11.5 6.5 11.2761 6.5 11V7C6.5 5.54131 7.07946 4.14236 8.11091 3.11091C9.14236 2.07946 10.5413 1.5 12 1.5C13.4587 1.5 14.8576 2.07946 15.8891 3.11091C16.9205 4.14236 17.5 5.54131 17.5 7V11C17.5 11.2761 17.2761 11.5 17 11.5C16.7239 11.5 16.5 11.2761 16.5 11V7C16.5 5.80653 16.0259 4.66193 15.182 3.81802C14.3381 2.97411 13.1935 2.5 12 2.5Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lock.cb3c79d1c2c753f06ba8a498b9c44c1f.svg";